import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionLike } from 'rxjs';

import { SessionStorageService } from '@shared/services';
import { FilterModel, DropdownModel, SidebarRouteExtended, TogglerModel } from '@shared/models';

@Component({
  selector:     'list-header',
  templateUrl:  'list-header.component.html',
  host: { class: 'am-flex-column gap-s bg-white p-m b-radius-wide' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ListHeaderComponent implements OnInit, OnDestroy {
  @Input() entriesLength:      number;
  @Input() searchTooltipItems: string[];
  @Input() searchEntryType:    string;

  @Input() filtersName:        string;
  @Input() togglersName:       string;
  @Input() dropdownsName:      string;
  @Input() button:             any;

  @Input() disablePrint:       boolean;
  @Input() disableExcel:       boolean;
  @Input() skipInitLoad:       boolean;
  @Input() loading:            boolean;

  @Output() buttonCallback   = new EventEmitter<any>();
  @Output() togglersChanged  = new EventEmitter<any>();
  @Output() filtersChanged   = new EventEmitter<any>();
  @Output() dropdownsChanged = new EventEmitter<any>();

  @Output() print            = new EventEmitter<any>();
  @Output() excel            = new EventEmitter<any>();
  @Output() callback         = new EventEmitter<any>();

  subscriptions: SubscriptionLike[] = [];
  activeTab:     SidebarRouteExtended;
  filters:       FilterModel[];
  togglers:      TogglerModel[];
  dropdowns:     DropdownModel[];

  constructor(
    private sessionStorageService:  SessionStorageService
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(this.sessionStorageService.activeTab.subscribe(activeTab => this.activeTab = activeTab));
    if (this.filtersName  ) this.subscriptions.push(this.sessionStorageService.headerFilters.subscribe(filters     => this.filters   = filters[  this.filtersName ]));
    if (this.togglersName ) this.subscriptions.push(this.sessionStorageService.headerTogglers.subscribe(togglers   => this.togglers  = togglers[ this.togglersName]));
    if (this.dropdownsName) this.subscriptions.push(this.sessionStorageService.headerDropdowns.subscribe(dropdowns => this.dropdowns = dropdowns[this.dropdownsName]));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptions = [];
  }

}
